import {
  ContentQualityQuestionData,
  SequencedQuestionResponse,
} from '@amzn/awscat-pattern-library-service-model';
import { JsonObject, JsonProperty } from 'json2typescript';

@JsonObject('ContentQualityQuestionnaireState')
export class ContentQualityQuestionnaireState {
  public static create(questionnaireState: ContentQualityQuestionnaireState) {
    return Object.assign(new ContentQualityQuestionnaireState(), questionnaireState);
  }

  public static createNew(
    questions: ContentQualityQuestionData[],
    responses: SequencedQuestionResponse[],
  ) {
    return Object.assign(new ContentQualityQuestionnaireState(), {
      questions,
      responses,
    });
  }

  @JsonProperty('questions', [ContentQualityQuestionData])
  // @ts-expect-error TS2322 - strict migration
  questions: ContentQualityQuestionData[] = undefined;
  @JsonProperty('responses', [SequencedQuestionResponse])
  // @ts-expect-error TS2322 - strict migration
  responses: SequencedQuestionResponse[] = undefined;
}
